import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { ContactSection } from './ContactSection';
import { LocationMap } from './LocationMap';
import { InstagramFeed } from './InstagramFeed';
import { QRCodeBlock } from './QRCodeBlock';
import { Language, translations } from '../utils/translations';
interface BookingModalProps {
  isOpen: boolean;
  onClose: () => void;
  theme: string;
  mode: string;
  lang: Language;
}
export function BookingModal({
  isOpen,
  onClose,
  theme,
  mode,
  lang
}: BookingModalProps) {
  const t = translations[lang];
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-48" data-mp="6pdjgjmgmu5p">
      {isOpen && <div className="fixed inset-0 z-[100] flex items-end justify-center md:items-center" data-id="element-49" data-mp="1og0w5xjfy3o">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="absolute inset-0 bg-[var(--black-alpha-60)] backdrop-blur-sm" data-id="element-50" data-mp="2bag3pmrtp6t1" />
          <motion.div initial={{
        y: '100%'
      }} animate={{
        y: 0
      }} exit={{
        y: '100%'
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 200
      }} className="relative flex h-[85vh] w-full max-w-[480px] flex-col overflow-hidden rounded-t-[32px] border-t border-zinc-800 bg-zinc-950 shadow-2xl md:h-[80vh] md:rounded-[32px] md:border" data-id="element-51" data-mp="21bqvklpqb0pz">
            <div className="flex items-center justify-between border-b border-zinc-800 px-6 py-4 bg-zinc-950 z-10" data-id="element-52" data-mp="1ijehx2tmkd0j">
              <h2 className="text-lg font-bold text-zinc-50" data-id="element-53" data-mp="1ni8038juws71">{t.bookingTitle}</h2>
              <button onClick={onClose} className="rounded-full bg-zinc-900 p-2 text-zinc-400 transition-colors hover:bg-zinc-800 hover:text-zinc-50" data-id="element-54" data-mp="18pegbaxjxpwk">
                <XIcon className="h-5 w-5" data-id="element-55" data-mp="ujw01xef5qp7" />
              </button>
            </div>
            
            <div className="flex-1 overflow-y-auto p-5 space-y-6 pb-10" data-id="element-56" data-mp="pozvxyvwrcvq">
              <LocationMap lang={lang} data-id="element-57" data-mp="ksro76k1ilyl" />
              <ContactSection lang={lang} data-id="element-58" data-mp="kpn8bbx7q1s3" />
              <QRCodeBlock theme={theme} mode={mode} lang={lang} data-id="element-59" data-mp="fty7z6ddcguq" />
              <InstagramFeed lang={lang} data-id="element-60" data-mp="1dgdoo5xz1ah8" />
              
              <div className="pt-6 pb-4 text-center text-[14px] font-medium text-zinc-500" data-id="element-61" data-mp="1dg5dqjlesf8o">
                {t.footerText}{' '}
                <a href="https://linkery.art/" target="_blank" rel="noopener noreferrer" className="font-bold text-zinc-400 hover:text-gold-500 transition-colors" data-id="element-62" data-mp="18fpw3fu3glkw">
                  Linkery
                </a>
              </div>
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}